import clsx from "clsx";
import React, { FC, memo, useEffect } from "react";

import Close from "~/components/Icons/Close";
import Error from "~/components/Icons/Notifications/Error";
import Info from "~/components/Icons/Notifications/Info";
import Success from "~/components/Icons/Notifications/Success";
import Warning from "~/components/Icons/Notifications/Warning";
import { NOTIFICATIONS } from "~/constans/notifications";

import s from "./styles.less";

interface PropsNotification {
  actionClose?: (boolean) => void;
  type: string;
  content: string;
  duration?: number | null;
}

const Notification: FC<PropsNotification> = ({
  content,
  type,
  actionClose,
  duration,
}) => {
  const Icon =
    (type === NOTIFICATIONS.success && Success) ||
    (type === NOTIFICATIONS.info && Info) ||
    (type === NOTIFICATIONS.warning && Warning) ||
    (type === NOTIFICATIONS.error && Error);

  useEffect(() => {
    const timer = setTimeout(actionClose, duration ?? 8000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={clsx({
        [s.notification_message]: true,
        [s[type]]: true,
      })}
    >
      <div className={s.notification_message__icon}>
        <Icon />
      </div>
      <div className={s.notification_message__content}>{content}</div>
      <div className={s.notification_message__close_btn} onClick={actionClose}>
        <Close fill={"#D8D8D8"} />
      </div>
    </div>
  );
};

export default memo(Notification);
